import Deferred from './lib/Deferred';

/**
 * 分步读取文件内容
 * @param  {[type]} file [description]
 * @param  {[type]} opt  [description]
 * @return {[type]}      [description]
 */
const readFileByStep = (file, opt = {}) => {
  let type = opt.type || 'base64',
    fragment = opt.fragment || 64 * 1024,
    onStep = opt.onStep || function() {},
    onEnd = opt.onEnd || function() {},
    onFail = opt.onFail || function() {},
    total = file.size,
    reader,
    start = 0,
    end = 0;

  if (type === 'base64') {
    reader = readerFile;
  } else if (type === 'int8Array') {
    reader = readerFileAsInt8Array;
  } else if (type === 'arrayBuffer') {
    reader = readerFileAsArrayBuffer;
  } else {
    reader = readerFileAsBinary;
  }

  function readAndCal() {
    end = Math.min(total, start + fragment);

    reader(file, start, end)
      .done(data => {
        onStep(data, (end / total) * 100);

        if (end >= total) {
          onEnd();
        } else {
          start = end;

          readAndCal();
        }
      })
      .fail(err => {
        onFail({
          ret: CONST.REPORT.READ_FILE_ERROR,
          message: err.message || 'read file error',
          info: err,
        });

        logger.log('read file error ' + err.message);
      });
  }

  readAndCal();
};

const readerFile = (file, start, end) => {
  let defer = new Deferred(),
    h5_file_reader = new FileReader();

  h5_file_reader.onload = function(e) {
    let slice = e.target.result.indexOf('base64,') + 7;
    defer.resolve(e.target.result.slice(slice));
  };

  h5_file_reader.onerror = function(e) {
    defer.reject(e);
  };

  h5_file_reader.readAsDataURL(blobFile(file, start, end));

  return defer;
};

const readerFileAsBlob = (file, start, end, contentType) => {
  let defer = new Deferred();

  defer.resolve(blobFile(file, start, end, contentType));

  return defer;
};

const blobToBase64 = blob => {
  let defer = new Deferred(),
    h5_file_reader = new FileReader();

  h5_file_reader.onload = function(e) {
    let slice = e.target.result.indexOf('base64,') + 7;
    defer.resolve(e.target.result.slice(slice));
  };

  h5_file_reader.onerror = function(e) {
    defer.reject(e);
  };

  h5_file_reader.readAsDataURL(blob);

  return defer;
};

const readerFileAsInt8Array = (file, start, end) => {
  let defer = new Deferred(),
    h5_file_reader = new FileReader();

  h5_file_reader.onload = function(e) {
    let int8Array = new Int8Array(e.target.result);
    defer.resolve(int8Array);
  };

  h5_file_reader.onerror = function(e) {
    defer.reject(e);
  };

  if (h5_file_reader.readAsArrayBuffer) {
    h5_file_reader.readAsArrayBuffer(blobFile(file, start, end));
  } else {
    defer.reject(new Error('no readAsBinaryString or readAsArrayBuffer'));
  }

  return defer;
};

const readerFileAsArrayBuffer = (file, start, end) => {
  let defer = new Deferred(),
    h5_file_reader = new FileReader();

  h5_file_reader.onload = function(e) {
    defer.resolve(e.target.result);
  };

  h5_file_reader.onerror = function(e) {
    defer.reject(e);
  };

  if (h5_file_reader.readAsArrayBuffer) {
    h5_file_reader.readAsArrayBuffer(blobFile(file, start, end));
  } else {
    defer.reject(new Error('no readAsBinaryString or readAsArrayBuffer'));
  }

  return defer;
};

//IE10不支持readAsBinaryString
const readerFileAsBinary = (file, start, end) => {
  let defer = new Deferred(),
    h5_file_reader = new FileReader(),
    isArrayBuffer;

  h5_file_reader.onload = function(e) {
    let binaryString = '';
    if (isArrayBuffer) {
      let bytes = new Uint8Array(e.target.result);
      for (let i = 0, len = bytes.byteLength; i < len; i++) {
        binaryString += String.fromCharCode(bytes[i]);
      }
    } else {
      binaryString = e.target.result;
    }
    defer.resolve(binaryString);
  };

  h5_file_reader.onerror = function(e) {
    defer.reject(e);
  };

  if (h5_file_reader.readAsBinaryString) {
    h5_file_reader.readAsBinaryString(blobFile(file, start, end));
  } else if (h5_file_reader.readAsArrayBuffer) {
    isArrayBuffer = true;
    h5_file_reader.readAsArrayBuffer(blobFile(file, start, end));
  } else {
    defer.reject(new Error('no readAsBinaryString or readAsArrayBuffer'));
  }

  return defer;
};

/**
 * The Blob.slice() method is used to create a new Blob object containing the data in the specified range of bytes of the source Blob.
 * @param  {[type]} file  [description]
 * @param  {[type]} start [description]
 * @param  {[type]} end   [description]
 * @return {[type]}       [description]
 */
const blobFile = (file, start, end, contentType = '') => {
  if (file.webkitSlice) {
    return file.webkitSlice(start, end, contentType);
  } else if (file.mozSlice) {
    return file.mozSlice(start, end, contentType);
  } else {
    return file.slice(start, end, contentType);
  }
};

export default {
  readerFile,
  readerFileAsBinary,
  readerFileAsBlob,
  readerFileAsInt8Array,
  readerFileAsArrayBuffer,
  blobFile,
  readFileByStep,
  blobToBase64,
};
